const REQUEST_START = 'cv-flow/REQUEST_START';
const REQUEST_FAILED = 'cv-flow/REQUEST_FAILED';

const FETCH_REPORT = 'cv-flow/FETCH_REPORT';
const FETCH_REPORT_SUCCEEDED = 'cv-flow/FETCH_SUCCEEDED';

const UPDATE_PAGE = 'cv-flow/UPDATE_PAGE';
const UPDATE_SORT = 'cv-flow/UPDATE_SORT';

export default {
  REQUEST_START,
  REQUEST_FAILED,

  FETCH_REPORT,
  FETCH_REPORT_SUCCEEDED,

  UPDATE_PAGE,
  UPDATE_SORT,
};
